import type { PolicySectionsType } from '@components/policy-sections'
import { Text } from '@components/text'
import { RichText } from '@contentful-components/rich-text'
import { checkSubsection } from '@lib/utils/policy'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './policy-sections.module.scss'

export const PolicySections: FunctionComponent<Props> = ({ sections }) => {
    if (sections?.length === 0) {
        return null
    }

    return (
        <div className={styles['policy-sections']}>
            {sections?.map((section) => {
                const isSubsection = checkSubsection(section?.title ?? '')

                return (
                    <section
                        id={section.anchor}
                        key={section.anchor}
                        className={classNames(
                            styles['policy-section'],
                            isSubsection &&
                                styles['policy-section--subsection'],
                        )}
                    >
                        <Text
                            typeStyle='body-lg'
                            bold
                            className={styles['policy-section--title']}
                        >
                            {section.title}
                        </Text>
                        <Text
                            tag='div'
                            typeStyle='body-lg'
                            className={styles['policy-section--content']}
                        >
                            <RichText source={section.content} />
                        </Text>
                    </section>
                )
            })}
        </div>
    )
}

export default PolicySections

interface Props {
    sections?: PolicySectionsType
}
